// Keep this module identical in frontend/src/validation and backend/validation.
// Both applications build independently; the validation test verifies parity.
const LIMITS = { nombres: 100, cedula: 10, numeroFactura: 100, fechaCumpleanos: 10, contacto: 15 };
const LABELS = { nombres: 'Nombres', cedula: 'Cédula', numeroFactura: 'Número de factura', fechaCumpleanos: 'Fecha de cumpleaños', contacto: 'Teléfono' };

function todayLocal(now = new Date()) {
  return [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('-');
}

function validateField(field, raw, today = todayLocal()) {
  if (typeof raw !== 'string') return 'Ingresa un valor de texto válido.';
  if (raw.length > LIMITS[field]) return `${LABELS[field]}: máximo ${LIMITS[field]} caracteres.`;
  const value = raw.trim();
  if (!value) return 'Este campo es obligatorio.';
  switch (field) {
    case 'nombres':
      if (value.length < 2 || !/^[\p{L}\p{M}]+(?:[ '\u2019-][\p{L}\p{M}]+)*$/u.test(value)) return 'Escribe tus nombres usando letras, espacios, apóstrofes o guiones (2 a 100 caracteres).';
      break;
    case 'cedula':
      if (!/^\d{10}$/.test(value)) return 'La cédula debe tener exactamente 10 dígitos, sin letras ni símbolos.';
      break;
    case 'numeroFactura':
      if (!/^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/.test(value)) return 'Usa letras, números y guiones, sin espacios (máximo 100 caracteres).';
      break;
    case 'fechaCumpleanos': {
      const date = new Date(`${value}T00:00:00Z`);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) return 'Ingresa una fecha válida.';
      if (value < '1900-01-01' || value > today) return 'La fecha debe estar entre 1900 y hoy; no puede ser futura.';
      if (value.slice(5, 7) !== '09') return 'Esta campaña aplica para cumpleaños de septiembre.';
      break;
    }
    case 'contacto': {
      if (!/^\d{7,15}$/.test(value)) return 'Ingresa un teléfono de 7 a 15 dígitos.';
      break;
    }
    default: return 'Campo no válido.';
  }
  return '';
}

function validateParticipant(raw, { partial = false, today = todayLocal() } = {}) {
  const data = {};
  const errors = {};
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return { data, errors: { form: 'Envía un formulario válido.' } };
  for (const field of Object.keys(LIMITS)) {
    if (partial && !Object.prototype.hasOwnProperty.call(raw, field)) continue;
    const error = validateField(field, raw[field], today);
    if (error) errors[field] = error;
    else data[field] = raw[field].trim();
  }
  if (!partial) {
    if (raw.aceptaTerminos !== true) errors.aceptaTerminos = 'Debes aceptar los términos y condiciones.';
    else data.aceptaTerminos = true;
  }
  if (partial && Object.prototype.hasOwnProperty.call(raw, 'activo')) {
    if (typeof raw.activo !== 'boolean') errors.activo = 'El estado activo debe ser verdadero o falso.';
    else data.activo = raw.activo;
  }
  return { data, errors };
}

module.exports = { LIMITS, todayLocal, validateField, validateParticipant };
